import * as React from "react";
import styled from "styled-components";
import { Link } from "../../shared/Link";
import { toREM, toVWDesktop } from "../../../helpers/styles";
import * as CommonHeaderTypes from "../types";

export type DrawerSubMenuItemProps = {
  className?: string;
  onClick: (subMenuItem: CommonHeaderTypes.SubMenuItem) => void;
  subMenuItem: CommonHeaderTypes.SubMenuItem;
  active: boolean;
  productsVariant?: boolean;
};

const DrawerSubMenuItem = ({
  className,
  onClick,
  active,
  subMenuItem,
  productsVariant = false,
}: DrawerSubMenuItemProps) => {
  if (!subMenuItem) return;

  const hasLink = "link" in subMenuItem && !!subMenuItem.link;
  const hasOptions =
    "options" in subMenuItem &&
    Array.isArray(subMenuItem.options) &&
    subMenuItem.options.length > 0;

  return (
    <Container
      className={className}
      active={active}
      productsVariant={productsVariant}
      data-drawer-submenu-trigger={hasOptions ? "true" : undefined}
      onClick={(event: React.MouseEvent<HTMLAnchorElement>) => {
        if (!hasLink) {
          event.preventDefault();
        }
        onClick(subMenuItem);
      }}
      onMouseEnter={() => onClick(subMenuItem)}
      onFocus={() => onClick(subMenuItem)}
      role={!hasLink ? "button" : undefined}
      aria-haspopup={hasOptions ? "menu" : undefined}
      aria-expanded={hasOptions ? active : undefined}
      to={hasLink ? subMenuItem.link : "#"}
    >
      {subMenuItem.label}
    </Container>
  );
};

const Container = styled(Link)<{ active?: boolean; productsVariant?: boolean }>`
  cursor: pointer;
  border: none;
  background-color: ${(props) => (props.active ? "#012604" : "transparent")};
  color: ${(props) =>
    props.active ? "#b5dd71" : props.productsVariant ? "#012604" : "#012102"};
  font-family: "GT Alpina";
  font-size: ${toREM(16)}rem;
  font-weight: 300;
  line-height: 1;
  letter-spacing: ${toREM(-0.64)}rem;
  margin-top: ${(props) => (props.productsVariant ? 0 : `${toVWDesktop(5)}vw`)};
  margin-bottom: ${(props) =>
    props.productsVariant ? 0 : `${toVWDesktop(5)}vw`};
  min-height: ${toREM(25)}rem;
  text-transform: none;
  width: fit-content;
  text-decoration: none;
  padding: ${toVWDesktop(5)}vw;
  border-radius: ${toVWDesktop(3)}vw;
  white-space: nowrap;
  transition: background-color 220ms ease, color 220ms ease;

  &:hover {
    background-color: #012604;
    color: #b5dd71;
  }

  &:focus-visible {
    background-color: #012604;
    color: #b5dd71;
    outline: 1px solid #012604;
    outline-offset: 2px;
  }
`;

export default DrawerSubMenuItem;
